<template>
  <app-graph
    :traces="traces"
    :default-range-size="defaultRangeSize"
    :title="selectedTrialName"
    :graph-type="graphType"
  />
</template>

<script>
import _ from 'lodash'
import AppGraph from '@/components/common/AppGraph'
import { getXAxis, GraphTypes, MONTHS_TO_DISPLAY, TraceTypes } from '@/helpers/graph-helper'
import trialSummaryService from '@/services/trial-summary-service'
import { vuetifyColors } from '@/assets/vuetify-config'
import { summaryValues } from '@/helpers/summary-value-helper'

export default {
  components: {
    AppGraph
  },
  props: {
    editedSite: { type: Object, default: null },
    orgTrialExternalId: { type: String, default: null },
    trialExternalId: { type: String, default: null },
    selectedTrialName: { type: String, default: null },
    trialId: { type: String, default: null }
  },
  data() {
    return {
      loading: true,
      trends: []
    }
  },
  computed: {
    graphType() {
      return GraphTypes.STACKED_BAR
    },
    sortedTrends() {
      return _.sortBy(this.trends, 'trendDate')
    },
    defaultRangeSize() {
      return MONTHS_TO_DISPLAY
    },
    x() {
      return getXAxis(this.sortedTrends)
    },
    enrolledTrace() {
      return _.merge(
        { line: { color: vuetifyColors.success }, type: 'scatter' },
        this.getTraceFromTrends(this.sortedTrends, TraceTypes.ENROLLED, 'Enrolled')
      )
    },
    notPreScreenedTrace() {
      return _.merge(
        { type: 'bar', marker: { color: vuetifyColors.mediumTwo } },
        this.getTraceFromTrends(this.sortedTrends, TraceTypes.NOT_PRE_SCREENED, 'Not Pre-Screened')
      )
    },
    preScreenedTrace() {
      return _.merge(
        { type: 'bar', marker: { color: vuetifyColors.primary } },
        this.getTraceFromTrends(this.sortedTrends, TraceTypes.PRE_SCREENED, 'Pre-Screened')
      )
    },
    traces() {
      return [this.enrolledTrace, this.preScreenedTrace, this.notPreScreenedTrace]
    },
    trendRequestParams() {
      return {
        trialId: this.trialId,
        cumulative: false,
        summaryValues: [
          summaryValues.TREND_DATE,
          summaryValues.TRIAL_ID,
          summaryValues.TRIAL_FRIENDLY_NAME,
          summaryValues.ORGANIZATION_EXTERNAL_ID,
          summaryValues.ORGANIZATION_NAME,
          summaryValues.PATIENT_ENROLLED_COUNT,
          summaryValues.PATIENT_NOT_CONSENTED_COUNT,
          summaryValues.PATIENT_NOT_ELIGIBLE_COUNT,
          summaryValues.PATIENT_AWAITING_REVIEW_COUNT,
          summaryValues.PATIENT_IN_REVIEW_COUNT
        ]
      }
    }
  },
  watch: {
    trendRequestParams() {
      this.fetchTrends()
    }
  },
  created() {
    this.fetchTrends()
  },
  methods: {
    async fetchTrends() {
      this.loading = true
      try {
        let { data } = await trialSummaryService.listTrialSummaryTrends(this.trendRequestParams)
        this.trends = _.map(data, trend => {
          return this.addTotals(trend)
        })
      } finally {
        this.loading = false
      }
    },
    addTotals(trend) {
      return _.merge({}, trend, {
        notPreScreenedCount: _.sum([trend.patientAwaitingReviewCount, trend.patientInReviewCount]),
        preScreenedCount: _.sum([
          trend.patientEnrolledCount,
          trend.patientNotConsentedCount,
          trend.patientNotEligibleCount
        ])
      })
    },
    getTraceFromTrends(trends, status, name) {
      return {
        x: this.x,
        y: _.map(trends, trend => trend[status]),
        name: name
      }
    }
  }
}
</script>
